import { Action, Subjects } from "casl/subjects";
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from "configs/AppConfig";
import { ROLE_TYPE } from "constants/common.constant";
import { currentUserRole, isPartnerAdmin, isSuperAdmin } from "utils/common";

export const NAV_PATH = {
  login: `${AUTH_PREFIX_PATH}/login`,
  dashboard: `${APP_PREFIX_PATH}/dashboard`,
  business_users: `${APP_PREFIX_PATH}/business_users`,
  active_users: `${APP_PREFIX_PATH}/active_users`,
  cancel_order: `${APP_PREFIX_PATH}/cancel_order`,
  orders: `${APP_PREFIX_PATH}/orders`,
  userAnalytics: `${APP_PREFIX_PATH}/user_analytics`,
  adminLogs: `${APP_PREFIX_PATH}/admin_logs`,
  accountDeletionLogs: `${APP_PREFIX_PATH}/account_deletion_logs`,
  adminDetails: `${APP_PREFIX_PATH}/admin_details`,
  users: `${APP_PREFIX_PATH}/users`,
  adminUsers: `${APP_PREFIX_PATH}/admin_users`,
  adminAccounts: `${APP_PREFIX_PATH}/admin_accounts`,
  partnerLeads: `${APP_PREFIX_PATH}/partner_leads`,
  collegeReconLeads: `${APP_PREFIX_PATH}/college_recon_leads`,
  navyLeads: `${APP_PREFIX_PATH}/navy_leads`,
  arcamaxLeads: `${APP_PREFIX_PATH}/arcamax_leads`,
  sponsoredScholarshipLeads: `${APP_PREFIX_PATH}/sponsored_scholarship_leads`,
  loans: `${APP_PREFIX_PATH}/loans`,
  partners: `${APP_PREFIX_PATH}/revenue_partners`,
  scholarships: {
    list: `${APP_PREFIX_PATH}/scholarships`,
    detail: (scholarshipId) =>
      `${APP_PREFIX_PATH}/scholarships/detail/${scholarshipId}`,
    root: `${APP_PREFIX_PATH}/scholarships`,
    wizard: `${APP_PREFIX_PATH}/scholarships/wizard`,
    template: `${APP_PREFIX_PATH}/scholarships/wizard/template`,
    applicant_detail: (id) =>
      `${APP_PREFIX_PATH}/scholarships/applicant_detail/${id}`,
    winners_list: (id) => `${APP_PREFIX_PATH}/scholarships/winners_list/${id}`,
    rank_criteria: (id) =>
      `${APP_PREFIX_PATH}/scholarships/rank_criteria/${id}`,
    edit: (id) => `${APP_PREFIX_PATH}/scholarships/edit/${id}`,
    targetAudience: (id) =>
      `${APP_PREFIX_PATH}/scholarships/wizard/${id}/target_audience`,
    dataCapturing: (id) =>
      `${APP_PREFIX_PATH}/scholarships/wizard/${id}/capturing`,
    deadline: (id) => `${APP_PREFIX_PATH}/scholarships/wizard/${id}/deadline`,
    attributes: (id) =>
      `${APP_PREFIX_PATH}/scholarships/wizard/${id}/attributes`,
    budget: (id) => `${APP_PREFIX_PATH}/scholarships/wizard/${id}/budget`,
    requirements: (id) =>
      `${APP_PREFIX_PATH}/scholarships/wizard/${id}/requirements`,
    escrow: (id) => `${APP_PREFIX_PATH}/scholarships/wizard/${id}/escrow`,
    publish: (id) => `${APP_PREFIX_PATH}/scholarships/wizard/${id}/publish`,
    manage: `${APP_PREFIX_PATH}/scholarships/sponsored_scholarships`,
  },
};

/*Supper User menu start*/
const superUserNav = [
  {
    key: "Dashboard",
    path: `${NAV_PATH.business_users}`,
    title: "Business Users",
    submenu: [],
  },
  {
    key: "Users",
    path: `${NAV_PATH.users}`,
    title: "Users",
    submenu: [],
  },
  {
    key: "admin",
    path: `${NAV_PATH.adminDetails}`,
    title: "Admin",
    submenu: [
      {
        key: "AdminUsers",
        path: `${NAV_PATH.adminUsers}`,
        title: "Admin Users",
        submenu: [],
      },
      {
        key: "AdminAccounts",
        path: `${NAV_PATH.adminAccounts}`,
        title: "Manage Admins",
        submenu: [],
      },
      {
        key: "adminLogs",
        path: `${NAV_PATH.adminLogs}`,
        title: "Admin Logs",
        submenu: [],
      },
      {
        key: "accountDeletionLogs",
        path: `${NAV_PATH.accountDeletionLogs}`,
        title: "Account Deletion Logs",
        submenu: [],
      },
    ],
  },
  {
    key: "Scholarships",
    path: `${NAV_PATH.scholarships.list}`,
    title: "Scholarship",
    submenu: [],
  },
  {
    key: "Loans",
    path: `${NAV_PATH.loans}`,
    title: "Loans",
    submenu: [],
  },
  {
    key: "partnerLeads",
    path: `${NAV_PATH.partnerLeads}`,
    title: "Partner Leads",
    submenu: [
      {
        key: "navyLeads",
        path: `${NAV_PATH.navyLeads}`,
        title: "Navy Leads",
        submenu: [],
      },
      {
        key: "collegeReconLeads",
        path: `${NAV_PATH.collegeReconLeads}`,
        title: "College Recon Leads",
        submenu: [],
      },
      {
        key: "arcamaxLeads",
        path: `${NAV_PATH.arcamaxLeads}`,
        title: "Aracmax(Cobra) Leads",
        submenu: [],
      },
      {
        key: "sponsoredScholarshipLeads",
        path: `${NAV_PATH.sponsoredScholarshipLeads}`,
        title: "Sponsored Scholarships",
        submenu: [],
      },
    ],
  },

  // {
  //   key: "AdminUsers",
  //   path: `${NAV_PATH.adminUsers}`,
  //   title: "Admin Users",
  //   submenu: [],
  // },

  {
    key: "Partners",
    path: `${NAV_PATH.partners}`,
    title: "Revenue Partners",
    submenu: [],
  },

  {
    key: "Orders",
    path: `${NAV_PATH.orders}`,
    title: "Orders",
    submenu: [],
  },
  {
    key: "User Analytics",
    path: `${NAV_PATH.userAnalytics}`,
    title: "User Analytics",
    submenu: [],
  },
  // {
  //   key: "Admin Logs",
  //   path: `${NAV_PATH.adminLogs}`,
  //   title: "Admin Logs",
  //   submenu: [],
  // },
  // {
  //   key: "activeUsers",
  //   path: `${NAV_PATH.active_users}`,
  //   title: "Subscribed Users",
  //   submenu: [],
  // },
  // {
  //   key: "cancelOrder",
  //   path: `${NAV_PATH.cancel_order}`,
  //   title: "Cancelled Orders",
  //   submenu: [],
  // },
];

// partner_admin only sees the Revenue section — no other nav items apply to them.
const partnerAdminNav = [
  {
    key: "Partners",
    path: `${NAV_PATH.partners}`,
    title: "Revenue",
    submenu: [],
  },
];

const navigationConfig = [...superUserNav];

export const navigationConfigMenu = () => {
  if (isPartnerAdmin()) {
    return [...partnerAdminNav];
  }

  // "Manage Admins" (create/deactivate other admin accounts) is super_admin only.
  // Clone the "admin" section's submenu so this filtering never mutates the
  // shared superUserNav singleton.
  const navigationConfig = superUserNav.map((item) => {
    if (item.key === "admin" && !isSuperAdmin()) {
      return {
        ...item,
        submenu: item.submenu.filter((sub) => sub.key !== "AdminAccounts"),
      };
    }
    return item;
  });

  return navigationConfig;
};

export default navigationConfig;
